import React from 'react';
import './Privacy.css';

function Privacy() {
  return (
    <section className="privacy-page">
      <div className="container">
        <header>
          <h1>Privacy Policy</h1>
        </header>
        <main className="privacy-content">
          <p className="last-updated">Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
          <article>
            <h2>1. Introduction</h2>
            <p>
              At SheetPilot ("we", "our", or "us"), we respect your privacy and are committed to protecting your personal information. This Privacy Policy explains how we collect, use, and safeguard your data when you purchase or use our online course (the "Service").
            </p>

            <h2>2. Information We Collect</h2>
            <p>
              We collect the following types of information:
            </p>
            <ul>
              <li><strong>Payment Information:</strong> When you purchase the Service, payment details (such as your credit card number) are processed securely through <strong>Stripe</strong>. We do not store or have access to your full credit card information.</li>
              <li><strong>Contact Information:</strong> Your email address may be collected to provide access to the course and communicate with you about your purchase.</li>
              <li><strong>Usage Data:</strong> We may collect information about how you access and use the Service, such as pages viewed and time spent.</li>
            </ul>

            <h2>3. How We Use Your Information</h2>
            <p>
              We use the collected information for the following purposes:
            </p>
            <ul>
              <li>To process your payment and provide access to the course</li>
              <li>To send you important updates or communications about the Service</li>
              <li>To improve and optimize the Service</li>
              <li>To comply with legal obligations</li>
            </ul>

            <h2>4. Payment Processing</h2>
            <p>
              All payments are processed by <strong>Stripe</strong>, a PCI-DSS compliant third-party payment processor. We do not store your credit card information on our servers. Stripe's use of your information is governed by their own Privacy Policy, available at <a href="https://stripe.com/privacy" target="_blank" rel="noopener noreferrer">stripe.com/privacy</a>.
            </p>

            <h2>5. Data Sharing and Disclosure</h2>
            <p>
              We do not sell, trade, or rent your personal information to third parties. We may share your information only in the following circumstances:
            </p>
            <ul>
              <li>With Stripe or other service providers necessary to process payments and deliver the Service</li>
              <li>If required by law or to protect our rights and safety</li>
            </ul>

            <h2>6. Data Retention</h2>
            <p>
              We retain your personal information only for as long as necessary to fulfill the purposes outlined in this Privacy Policy, unless a longer retention period is required by law.
            </p>

            <h2>7. Your Rights</h2>
            <p>
              Depending on your location, you may have the following rights regarding your personal data:
            </p>
            <ul>
              <li>The right to access, update, or delete your personal information</li>
              <li>The right to object to or restrict certain processing activities</li>
              <li>The right to data portability</li>
            </ul>
            <p>
              To exercise these rights, please contact us at <strong>support@mindlink.work</strong>.
            </p>

            <h2>8. Security</h2>
            <p>
              We implement reasonable security measures to protect your personal information. However, no method of transmission over the internet or electronic storage is 100% secure, and we cannot guarantee absolute security.
            </p>

            <h2>9. Children's Privacy</h2>
            <p>
              The Service is not intended for individuals under the age of 13. We do not knowingly collect personal information from children under 13.
            </p>

            <h2>10. Changes to This Privacy Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated "Last updated" date. We encourage you to review this Privacy Policy periodically.
            </p>

            <h2>11. Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy, please contact us at: <strong>support@mindlink.work</strong>
            </p>
          </article>
        </main>
      </div>
    </section>
  );
}

export default Privacy;
